import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "src/environments/environment";

import ApiVersionConstants from "../constants/api-version-constants";
import { User } from "../models/User";
import { UserSettings } from "../models/UserSettings";
export const WIMSServiceUser = "c4s_service_user";

@Injectable({
  providedIn: "root",
})
export class UserService {
  private baseUrl_V2 = `${environment.apiConfig.uri}/${ApiVersionConstants.V_2}/user`;

  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get<User[]>(this.baseUrl_V2);
  }

  get(id: number): Observable<User> {
    return this.http
      .get<User>(`${this.baseUrl_V2}/${id}`)
      .pipe(map((x) => new User().deserialize(x)));
  }

  userExistsInSpirit(email: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl_V2}/${email}/existsInSpirit`);
  }

  create(user: User): Observable<number> {
    return this.http.post<number>(this.baseUrl_V2, user);
  }

  update(user: User, id: number): Observable<number> {
    return this.http.put<number>(`${this.baseUrl_V2}/${id}`, user);
  }

  delete(id: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.baseUrl_V2}/${id}`);
  }

  getParams(): Observable<UserSettings> {
    return this.http.get<UserSettings>(`${this.baseUrl_V2}/params`);
  }

  public existsInAzure(userEmail: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl_V2}/${userEmail}/existsInAzure`);
  }
}
